module.exports = __webpack_public_path__ + "static/media/amit ji 2.6ef64115.png";